<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <h5>
          <b>Daftar Permintaan Barang Obral</b>
        </h5>
        <DataTable
          :value="items"
          class="p-datatable-outlets"
          :rows="limit"
          data-key="doc_number"
          :paginator="true"
          :rowHover="true"
          :filters="filters1"
          :loading="loading1"
          :lazy="true"
          :totalRecords="total_records"
          @page="getListBarangObral($event)"
        >
          <template #header>
            <div class="table-header">
              <div class="p-col p-mb-5">
                <div>
                  <AutoComplete
                    placeholder="Pilih Status"
                    id="status"
                    :dropdown="true"
                    :multiple="false"
                    v-model="selectedStatus"
                    :suggestions="autoFiltered"
                    @complete="searchStatus($event)"
                    field="name"
                  />
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div>
                  <InputText
                    type="text"
                    v-model="filters.doc_number"
                    placeholder="Nomer Bon"
                  />
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <div>
                  <InputText
                    id="doc-date"
                    type="date"
                    v-model="filters.doc_date"
                    placeholder="Tanggal bon"
                  />
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-3">
                <button
                  class="btn btn-primary"
                  @click="saveFilters"
                  style="width: 100%"
                >
                  Cari
                </button>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Menggambil data daftar permintaan barang obral. Mohon
            tunggu</template
          >
          <Column header="Nomor Bon">
            <template #body="slotProps">
              <span>{{ slotProps.data.doc_number }}</span>
            </template>
          </Column>
          <Column header="Tanggal Bon">
            <template #body="slotProps">
              <span>{{ slotProps.data.doc_date }}</span>
            </template>
          </Column>

          <Column header="Total Qty">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_qty }}</span>
            </template>
          </Column>

          <Column field="status" header="Status">
            <template #body="slotProps">
              <span
                :style="
                  slotProps.data.status === 1 ? 'color:green' : 'color:red'
                "
              >
                <b>{{ checkStatus(slotProps.data.status) }}</b>
              </span>
            </template>
          </Column>

          <Column
            headerStyle="width: 12rem"
            bodyStyle="text-align: center; overflow: visible"
          >
            <template #body="slotProps">
              <div>
                <router-link
                  :to="{
                    name: 'obral-detail',
                    query: { doc_number: slotProps.data.doc_number }
                  }"
                >
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-mr-2"
                  ></Button>
                </router-link>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDelete(slotProps.data)"
                  v-if="slotProps.data.status === 0 && user.role == 'RETURN'"
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>
        <br />

        <Dialog
          :visible.sync="deleteDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="warehouse_sale">
              Apakah kamu yakin ingin menghapus
              <b>{{ warehouse_sale.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteWarehouseSale(warehouse_sale.doc_number)"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  data() {
    return {
      filters: {
        warehouse: '',
        doc_date: '',
        doc_number: ''
      },
      selectedStatus: '',
      status: [
        { code: 0, name: 'Tertunda' },
        { code: 1, name: 'Disetujui' },
        { code: 2, name: 'Diproses' }
      ],
      moment: moment,
      filters1: {},
      loading1: null,
      expandedRows: [],
      autoFiltered: [],
      items: null,
      deleteDialog: false,
      confirmDialog: false,
      warehouse_sale: {},
      pageNumber: 1,
      totalItem: 0,
      totalPage: 1,
      limit: 10,
      total_records: 0
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getListBarangObral()
  },
  methods: {
    saveFilters() {
      this.getListBarangObral()
    },
    searchStatus(event) {
      this.autoFiltered = this.status.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },
    checkStatus(status) {
      if (status == 0) {
        // return Confirmed Hijau
        return 'Tertunda'
      } else if (status == 1) {
        // return Pending merah
        return 'Disetujui'
      } else {
        return 'Diproses'
      }
    },
    getListBarangObral(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }

      let status = ''

      if (this.selectedStatus == '') {
        status = ''
      } else {
        status = this.selectedStatus.code
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales/outgoings?status=${status}&doc_number=${this.filters.doc_number}&doc_date=${this.filters.doc_date}&limit=${this.limit}&page=${page}`
        )
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.items = response.data.data.warehouse_sales
            this.totalItem = Number(response.data.data.total)
            this.totalPage = Math.ceil(this.totalItem / this.limit)
            this.total_records = Number(response.data.data.total)
          } else {
            console.error('gagal get')
          }
        })
    },

    confirmDelete(warehouse_sale) {
      this.warehouse_sale = warehouse_sale
      this.deleteDialog = true
    },

    deleteWarehouseSale(doc_number) {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales?doc_number=${doc_number}`
        )
        .then(response => {
          this.deleteDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Barang Obral Dihapus',
              detail: 'Barang Obral barhasil dihapus',
              life: 3000
            })
            this.getListBarangObral(0)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal Menghapus',
              detail: 'Barang obral gagal dihapus',
              life: 3000
            })
            console.error(response.data.message)
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
